<template>
    <div>
        <input type="file" @change="getFile">
        <img :src="form.img" style="width: 50px" />
        
        <div style="padding: 1rem 0">
            <h5>Название услуги</h5>
            <label for="name-ru">RU</label>
            <b-form-input type="text" v-model="form.case_name.ru" name="name-ru" :state="inputState(form.case_name.ru)" />
            <label for="name-ua">UA</label>
            <b-form-input type="text" v-model="form.case_name.ua" name="name-ua" :state="inputState(form.case_name.ua)" />
            <label for="name-ua">EN</label>
            <b-form-input type="text" v-model="form.case_name.en" name="name-en" :state="inputState(form.case_name.en)" />
        </div>
        <div>
            <h5>Заголовок</h5>
            <label for="header-ru">RU</label>
            <b-form-input type="text" v-model="form.header.ru" name="header-ru" :state="inputState(form.header.ru)" />
            <label for="name-ua">UA</label>
            <b-form-input type="text" v-model="form.header.ua" name="header-ua" :state="inputState(form.header.ua)" />
            <label for="name-ua">EN</label>
            <b-form-input type="text" v-model="form.header.en" name="header-en" :state="inputState(form.header.en)" />
        </div>
        <div>
            <h5>Текст</h5>
            <label for="text-ru">RU</label>
            <b-form-textarea type="text" v-model="form.text.ru" name="text-ru" :state="inputState(form.text.ru)" />
            <label for="text-ua">UA</label>
            <b-form-textarea type="text" v-model="form.text.ua" name="text-ua" :state="inputState(form.text.ua)" />
            <label for="name-ua">EN</label>
            <b-form-textarea type="text" v-model="form.text.en" name="text-en" :state="inputState(form.text.en)" />
        </div>

        <div>
            <label for="url">Ссылка на проект</label>
            <b-form-input type="text" v-model="form.url" name="url" :state="inputState(form.url)" />
        </div>

        <div style="margin-top: 1rem">
            <button class="btn btn-info" style="width: 100%" @click="save">save</button>
        </div>
    </div>
</template>

<script>
import Data from '../../API.js'
export default {
    data() {
        return {
            form: {
                url: '',
                img: '',
                case_name: {
                    ru: '',
                    en: '',
                    ua: ''
                },
                header: {
                    ru: '',
                    en: '',
                    ua: ''
                },
                text: {
                    ru: '',
                    en:'',
                    ua: ''
                }
            },
            file: null
        }
    },
    methods: {
        inputState(i) {
            return Boolean(i);
        },
        getFile(event) {
            if (event.target.files && event.target.files.length) {
                const selectedFile = event.target.files[0];
                const reader = new FileReader();

                reader.onload = (event) => {
                    this.form.img = event.target.result;
                };

                reader.readAsDataURL(selectedFile);
            }
        },
        save() {
            this.form.token = localStorage.getItem('token')
            console.log('FORM', this.form)
            Data.addCases({ ...this.form })
                .then(json => {
                    if (json.data.status == 'done') {
                        this.$emit('saved')
                    }
                    else alert('произошла ошибка')
                })
        }
    }
}
</script>

<style scoped>
    
</style>



// WEBPACK FOOTER //
// src/components/case/addCase.vue